



export class ZalogujModel {
    email: string;
    haslo: string;
}